import React, { useEffect, useState } from "react";
import CustomModalLayout from "../../../web/Auth/CustomModalLayout";
import { getUser } from "services";
import { useDispatch } from "react-redux";
import { setBidderUser, setUser } from "store";
import BidderOnboardingFormV2 from "./BidderOnboardingFormV2";

interface OnboardingFormWrapperProps {
  open: any;
  setOpen: any;
}

export default function OnboardingFormWrapper({
  open,
  setOpen,
}: OnboardingFormWrapperProps) {
  const dispatch = useDispatch();

  useEffect(() => {
    (async () => {
      try {
        const userData: any = await getUser();
        dispatch(setUser(userData));
        dispatch(setBidderUser(userData));
        await new Promise((resolve) => setTimeout(resolve, 250));
      } catch (error) {
        console.log("error:onboardingFormWrapper---->>>", error);
      }
    })();
  }, []);

  return (
    <CustomModalLayout
      open={open}
      onClose={() =>
        // alert(
        //   "This is a mandatory process and cannot be closed at this stage. Please complete it to proceed."
        // )
        setOpen(false)
      }
      className="w-full max-w-[927px] overflow-y-auto max-h-[calc(100%-10px)] py-6 px-9"
    >
      <main className="max-h-svh" id="onboarding-form-top">
        <h3 className="font-semibold">Fill in the onboarding form</h3>
        {/* <p className="text-brand-textGrey text-sm">
          Please note that this form requires PAN validation. Kindly enter your
          PAN details to proceed with verification.
        </p> */}
        <BidderOnboardingFormV2
          onOuterSubmitComplete={() => {
            setOpen(false);
          }}
          excludeProfilePicture
        />
      </main>
    </CustomModalLayout>
  );
}
